import { FeeDefinitionStatus } from '@40seas/entities/fees';
import { EnumColor } from '@40seas/frontend/common/providers';

export const feeDefinitionColorMapping = {
    [FeeDefinitionStatus.Active]: 'success',
    [FeeDefinitionStatus.Archived]: 'secondary',
    [FeeDefinitionStatus.Inactive]: 'error',
} as { [key in FeeDefinitionStatus]: EnumColor };
